
const paths = require.context('./', true, /\.json$/).keys();
let content = []
for (let i = 0; i < 4; i++) {
    const file = require(`${paths[i]}`)
    content = content.concat(file)
}
export const Data = content



// WEBPACK FOOTER //
// ./src/config/en-US/swapV2/api/basic/index_share_to_v1.js